import { Component, OnInit, ViewChild, TemplateRef, OnDestroy, AfterViewInit } from '@angular/core';
import { GridService, IGrid, IToast, LayoutService, ToastService } from 'codex-lib';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RoutePages } from 'src/app/enum/route-pages';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EnvelopeEditService } from '../services/envelope-edit.service';
import { EnvelopeEditTabs } from 'src/app/enum/envelope-edit-tabs';
import * as R from 'ramda';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { IDropdownTab } from 'codex-lib/lib/interface/dropdownTab.interface';
export interface ITab {
  badgeValue?: number;
  badgeClass?: string;
  title: string;
}
@Component({
  selector: 'app-edit-envelope',
  templateUrl: './envelope-edit.component.html',
  styleUrls: ['./envelope-edit.component.scss']
})
export class EnvelopeEditComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('toolbarCodex') toolbar: TemplateRef<any>;
  @ViewChild('confirmBackModal') private confirmBackModal;

  activeModal: NgbActiveModal;
  subjectToggleViewer: Subscription;
  tabInformation: ITab = { title: 'envelopeEdit.information' };
  tabSignatories: ITab = { title: 'envelopeEdit.signatories' };
  tabSelected = 0;
  envelopeEditTabs = EnvelopeEditTabs;

  customOptions: IGrid = {
    classContent: 'viewer-content',
    classNavbar: 'viewer-navbar',
    hideOnColapse: true,
  };

  dropdown: IDropdownTab = {
    items: [
      {
        title: ''
      }
    ]
  };

  constructor(
    public envelopeEditService: EnvelopeEditService,
    public layoutService: LayoutService,
    private modalService: NgbModal,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
    private gridService: GridService) {
    this.layoutService.headerProp.next({ title: 'Edit envelope' });
    this.subjectToggleViewer = this.layoutService.clickButtonGoBackEventProp.subscribe((x) => this.showConfirmWindow());
  }

  ngOnInit(): void {
    this.gridService.toggleGrid();
    this.layoutService.toggleButtonCofirmGoBack(false);
  }

  ngOnDestroy(): void {
    this.subjectToggleViewer.unsubscribe();
    this.gridService.toggleGrid();
  }

  ngAfterViewInit(): void {
    this.layoutService.toolbarTemplateRef.next(this.toolbar);
  }

  showConfirmWindow() {
    this.activeModal = this.modalService.open(this.confirmBackModal);
  }

  disabledButtonCompleteEditing() {
    switch (this.tabSelected) {
      case EnvelopeEditTabs.Information:
        return !(this.envelopeEditService.getModelData(EnvelopeEditTabs.Information) as FormGroup).valid;
      case EnvelopeEditTabs.Signatory:
        return !(R.pathOr(0, ['length'], this.envelopeEditService.getModelData(EnvelopeEditTabs.Signatory).signatories) >= 1);
      default:
        break;
    }
  }

  canShowConfirmEditWindow(confirmModalContent) {
    const signatories = this.envelopeEditService.getModelData(EnvelopeEditTabs.Signatory)?.signatories ?? [];
    const hasInactiveRole = signatories.some(s => s.signatoryTypeRole && !s.signatoryTypeRole.isActive);
    if (hasInactiveRole) {
      const toast: IToast = {
        text: this.translateService.instant('envelope.signatory.toast.signatoryTypeRoleInactive'),
        autoHide: true,
        type: 'danger'
      };
      this.toastService.createNewToast(toast);
      return;
    }
    this.activeModal = this.modalService.open(confirmModalContent);
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  async confirmModalYesClick() {
    this.envelopeEditService.cancel();
    this.layoutService.toggleButtonCofirmGoBack(true);
    this.router.navigate([RoutePages.Root]);
    this.activeModal.dismiss();
  }

  tabSelect(event: any) {
    this.tabSelected = event;
  }

  confirmEditModalCompleteClick() {
    this.envelopeEditService.completeEdit();
    this.activeModal.dismiss();
  }
}